export default function AdminFormSection({ title, description, children, className = '' }) {
  return (
    <section className={`sm:col-span-2 ${className}`.trim()}>
      <div className="border-t border-border pt-6">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-primary">{title}</h3>
        {description ? <p className="mt-1.5 text-xs leading-relaxed text-text/60">{description}</p> : null}
        <div className="mt-4 grid gap-4 sm:grid-cols-2">{children}</div>
      </div>
    </section>
  )
}
